export default {
	globalFormAutoSave: {
		name: 'formAutoSave',
		expiredTime: 60 * 60 * 24 * 7
	}
};
